<app-page-breadcrumb pageTitle="Estados de Tarea"></app-page-breadcrumb>

<app-component-card>
  <div class="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-4">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 flex-1">
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Buscar</label>
        <input type="text" [(ngModel)]="filtroSearch" (ngModelChange)="buscar()"
          placeholder="Nombre o etiqueta..."
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"/>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Estado</label>
        <select [(ngModel)]="filtroActive" (ngModelChange)="buscar()"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
          <option value="">Todos</option>
          <option value="true">Activos</option>
          <option value="false">Inactivos</option>
        </select>
      </div>
    </div>
    <app-button variant="primary" (btnClick)="nuevo()">+ Nuevo estado</app-button>
  </div>

  @if (error) { <p class="mb-3 text-sm text-error-600 dark:text-error-400">{{ error }}</p> }

  @if (loading) {
    <div class="flex justify-center py-8"><div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div></div>
  } @else if (items.length === 0) {
    <p class="py-8 text-center text-sm text-gray-500 dark:text-gray-400">No hay estados registrados.</p>
  } @else {
    <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 dark:bg-gray-800">
          <tr>
            <th class="w-10 px-2 py-2"><span class="sr-only">Reordenar</span></th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-16">Orden</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Etiqueta</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Código</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-20">Color</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Flags</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-32">Estado</th>
            <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400 w-40">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 dark:divide-gray-700"
          cdkDropList
          cdkDropListLockAxis="y"
          [cdkDropListDisabled]="!canReorder || reordering"
          [cdkDropListData]="items"
          (cdkDropListDropped)="dropEstado($event)">
          @for (item of items; track trackById($index, item)) {
            <tr cdkDrag [cdkDragDisabled]="!canReorder || reordering"
              class="bg-white dark:bg-transparent hover:bg-gray-50 dark:hover:bg-gray-800/50">

              <!-- Preview flotante: el clon de un <tr> fuera de la tabla pierde las columnas,
                   así que se arrastra una etiqueta compacta con la etiqueta del estado. -->
              <ng-template cdkDragPreview>
                <div
                  class="flex items-center gap-2 rounded-lg border border-brand-300 bg-white px-4 py-2.5 text-theme-sm font-medium text-gray-800 shadow-theme-lg dark:border-brand-700 dark:bg-gray-900 dark:text-white/90">
                  <svg class="w-4 h-4 text-gray-400 dark:text-gray-500" fill="currentColor" viewBox="0 0 24 24">
                    <circle cx="9" cy="6" r="1.5" /><circle cx="15" cy="6" r="1.5" />
                    <circle cx="9" cy="12" r="1.5" /><circle cx="15" cy="12" r="1.5" />
                    <circle cx="9" cy="18" r="1.5" /><circle cx="15" cy="18" r="1.5" />
                  </svg>
                  {{ item.label }}
                </div>
              </ng-template>

              <!-- Asa de arrastre -->
              <td class="w-10 px-2 py-2 text-center">
                @if (canReorder) {
                <span cdkDragHandle
                  class="inline-flex p-1 rounded cursor-grab active:cursor-grabbing text-gray-300 hover:text-gray-500 dark:text-gray-600 dark:hover:text-gray-400 transition-colors"
                  title="Arrastrar para reordenar">
                  <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <circle cx="9" cy="6" r="1.5" /><circle cx="15" cy="6" r="1.5" />
                    <circle cx="9" cy="12" r="1.5" /><circle cx="15" cy="12" r="1.5" />
                    <circle cx="9" cy="18" r="1.5" /><circle cx="15" cy="18" r="1.5" />
                  </svg>
                </span>
                } @else if (puedeEditar) {
                <span
                  class="inline-flex p-1 rounded text-gray-200 dark:text-gray-800 cursor-not-allowed"
                  title="Quita los filtros para poder reordenar">
                  <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <circle cx="9" cy="6" r="1.5" /><circle cx="15" cy="6" r="1.5" />
                    <circle cx="9" cy="12" r="1.5" /><circle cx="15" cy="12" r="1.5" />
                    <circle cx="9" cy="18" r="1.5" /><circle cx="15" cy="18" r="1.5" />
                  </svg>
                </span>
                }
              </td>

              <td class="px-3 py-2 text-gray-500 dark:text-gray-400">{{ item.displayOrder ?? 0 }}</td>
              <td class="px-3 py-2 font-medium text-gray-900 dark:text-white">{{ item.label }}</td>
              <td class="px-3 py-2 font-mono text-xs text-gray-500">{{ item.name }}</td>
              <td class="px-3 py-2">
                @if (item.color) {
                  <span class="inline-block w-5 h-5 rounded border border-gray-200" [style.background-color]="item.color" [title]="item.color"></span>
                } @else { <span class="text-gray-400 text-xs">—</span> }
              </td>
              <td class="px-3 py-2">
                <div class="flex flex-wrap gap-1">
                  @if (item.isDefault) { <app-badge color="primary">Default</app-badge> }
                  @if (item.isFinal) { <app-badge color="success">Final</app-badge> }
                  @if (item.isCompletedTerminal) { <app-badge color="success">Terminal completado</app-badge> }
                  @if (item.isCancelledTerminal) { <app-badge color="error">Terminal cancelado</app-badge> }
                  @if (item.isSystem) { <app-badge color="warning">Sistema</app-badge> }
                </div>
              </td>
              <td class="px-3 py-2">
                @if (item.isActive) { <app-badge color="success">Activo</app-badge> }
                @else { <app-badge color="light">Inactivo</app-badge> }
              </td>
              <td class="px-3 py-2">
                <div class="flex items-center justify-end gap-1">
                  <button type="button" *appHasPermission="'tasks:edit'" (click)="editar(item)" title="Editar"
                    class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-gray-700">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                  </button>
                  <button type="button" (click)="toggle(item)" [title]="item.isActive ? 'Desactivar' : 'Activar'"
                    class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-gray-700">
                    @if (item.isActive) {
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
                      </svg>
                    } @else {
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                      </svg>
                    }
                  </button>
                  <button type="button" *appHasPermission="'tasks:delete'" (click)="eliminar(item)" title="Eliminar" [disabled]="item.isSystem"
                    class="p-1.5 rounded-lg text-gray-500 hover:bg-error-50 hover:text-error-600 dark:text-gray-400 dark:hover:bg-error-500/10 disabled:opacity-30 disabled:cursor-not-allowed">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</app-component-card>
